import { DashboardCard } from "../../dashboard-card";

export interface FormsContentProps {
  forms?: Array<{
    id: string;
    title: string;
    responses: string;
    date: string;
  }>;
  onFormSelect?: (formId: string, formTitle: string) => void;
}

export function FormsContent({ forms = [], onFormSelect }: FormsContentProps) {
  return (
    <div className="flex flex-col gap-4 overflow-auto p-1">
      {forms.map((form) => (
        <div key={form.id} className="cursor-pointer" onClick={() => onFormSelect?.(form.id, form.title)}>
          <DashboardCard
            statusLabel=""
            title={form.title}
            subtitle=""
            subtitleSecondary=""
            assignees={[]}
            description={`${form.responses} responses`}
            dueDate=""
            priority=""
            timestamp={undefined}
            showUnreadDot={false}
          />
        </div>
      ))}
    </div>
  );
}
